import React from 'react';

class Tab extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <li>
                <div className={'menuButton'}>
                    <p>{this.props.header}</p>
                </div>
            </li>
        );
    }
}

Tab.propTypes = {
    header: React.PropTypes.string,
};

export default Tab;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsTab/Tab.jsx
 **/